import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { WellHeaderInfoService } from 'app/modules/well-header-information/services/well-header-info.service';
import { EditWellProdModalComponent } from 'app/modules/well-production-status/component/edit-well-prod-modal/edit-well-prod-modal.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { noWhitespaceValidator } from 'app/core/shared/helper/form.helper';
import module from "app/modules/well-header-information/well-header-information.module";

@Component({
  selector: 'app-edit-company-modal',
  templateUrl: './edit-company-modal.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: module,
  styleUrls: ['./edit-company-modal.component.scss']
})
export class EditCompanyModalComponent {
  public companyForm: FormGroup
  public isSuccess: boolean = false
  public isLoading: boolean = false

  constructor(
    public dialogRef: MatDialogRef<EditWellProdModalComponent>,
    @Inject(MAT_DIALOG_DATA) public companyData: any,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private wellHeaderInfoService: WellHeaderInfoService) { }

  ngOnInit() {
    this.companyForm = this.initializeForm()
  }

  initializeForm() {
    return this.fb.group({
      id: this.companyData.operatorId,
      companyLongName: [this.companyData.longName, [Validators.required, noWhitespaceValidator()]],
      companyShortName: [this.companyData.name, [Validators.required, noWhitespaceValidator()]],
      country: [this.companyData.region, [Validators.required, noWhitespaceValidator()]],
      location: [this.companyData.location, [Validators.required, noWhitespaceValidator()]],
      remarks: this.companyData.remarks
    })
  }

  updateCompany() {
    this.isLoading = true

    this.wellHeaderInfoService.updateCompany(this.companyForm.value).subscribe(
      (res) => {
        if (res.isSuccess) {
          this.isSuccess = true
          this.closeDialog()
        }

        this.isLoading = false
      }, (err) => this.isLoading = false)
  }

  closeDialog(): void {
    this.dialogRef.close(this.isSuccess);
  }

  get companyLongName() {
    return this.companyForm.get('companyLongName');
  }

  get companyShortName() {
    return this.companyForm.get('companyShortName');
  }

  get country() {
    return this.companyForm.get('country');
  }

  get location() {
    return this.companyForm.get('location');
  }
}
